var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFolder = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#5C5F62",
  fillRule: "evenodd",
  d: "M1 3.833C1 2.821 1.82 2 2.833 2h3.564c.694 0 1.33.392 1.64 1.014l.393.787h4.737c1.012 0 1.833.82 1.833 1.833v6.281c0 1.013-.82 1.834-1.833 1.834H2.833A1.835 1.835 0 0 1 1 11.916zm7 .664-.623.312-.032-.064-.002-.005-.552-1.103a.44.44 0 0 0-.394-.244H2.833a.44.44 0 0 0-.44.44v8.082a.44.44 0 0 0 .44.44h10.334a.44.44 0 0 0 .44-.44v-6.28a.44.44 0 0 0-.44-.441H8zm0 0v.697a.7.7 0 0 1-.623-.385z",
  clipRule: "evenodd"
})));
export default SvgFolder;